import * as React from "react";
import { observer, inject } from "mobx-react";
import { hashHistory } from "react-router";
import { ScreenMode } from "../../../models/enums";
import SeekerStore from "../../../stores/seekerStore";
import { Row, Col } from "react-flexbox-grid";
import * as s from "./videoOps.css";

interface IParams {
  opId: string;
}

@inject("store") @observer
export default class VideoOps extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    if (this.props.store.opportunityStore.selectedOp.videoUrl === null || this.props.store.opportunityStore.selectedOp.videoUrl === ""){
      return null;
    }
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const videoUrl: string = this.props.store.opportunityStore.selectedOp.videoUrl + "?title=0&byline=0&portrait=0";   //https://player.vimeo.com/video/134950107
    return (<Row><Col xs={12} className={s.col}>
      {mode === ScreenMode.Mobile && <iframe src={videoUrl} width="320" height="180" frameBorder="0" allowFullScreen ></iframe>}
      {mode === ScreenMode.Tablet && <iframe src={videoUrl} width="640" height="360" frameBorder="0" allowFullScreen ></iframe>}
      {mode === ScreenMode.Desktop && <iframe src={videoUrl} width="790" height="444" frameBorder="0" allowFullScreen ></iframe>}
     </Col></Row>)
  }
}




// WEBPACK FOOTER //
// ./src/components/opportunity/videoOps/index.tsx